import { numberField, textField } from '@templates/AddNewItemModal/templates'
import { Fields } from '@templates/AddNewItemModal/Content'

const useChapterFormFields = (): Fields => {
  return [
    {
      fields: [
        textField({
          name: 'title',
          label: 'Название раздела',
          isRequired: true,
          placeholder: 'Название раздела',
        }),
        {
          ...numberField({
            name: 'hoursCount',
            label: 'Количество часов',
            isRequired: true,
            placeholder: 'Количество часов',
          }),
          rules: {
            required: {
              value: true,
              message: 'Заполните количество часов',
            },
          },
        },
      ],
    },
  ]
}

export default useChapterFormFields
